import i18next from 'i18next';
import { useTranslation as useTranslationOrg } from 'react-i18next';
import { defaultNS } from '../settings';
import i18nConfig from '../config';

// Flag to ensure i18next is initialized only once
let hasInit = false;

const initialize = () => {
  if (hasInit) return;
  hasInit = true;

  i18nConfig;
};

// Custom hook to use translation
export const useTranslation = (
  ns: string | string[] = defaultNS,
  options: any = {},
) => {
  initialize();
  return useTranslationOrg(ns, options);
};

export default i18next;
